module.exports = __webpack_public_path__ + "60e55a09da0a2465d0cca736f1d194ce.svg";